import React, { useEffect, useState } from "react";
import "./GetMobileApp.scss";
import appLogo from "../assets/images/pictures/app-logo.png";
import { addAppDownloadUTMParams, getMobileOSIfWeb } from "../utils/helpers";
import { MOBILE_APP_URLS, WHITE_LOGO_CDN_URL } from "../constants/constants";
import { useScrollLock } from "../hooks/useScrollLock";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux-stores/store";
import { analyticsLog } from "../lib/analytics";
import AppLogo from "../assets/images/influns-logo.png"
import GridBG from "../assets/images/grid-bg.png"

const APP_POPUP_IGNORE_KEY = "appPopupIgnoredAt";
const IGNORE_DURATION_MS = 10 * 60 * 1000;
const POPUP_DELAY_MS = 3000;

const GetMobileApp: React.FC = () => {
    const socialAccounts = useSelector((state: RootState) => state.influencer.social_accounts);
    const [appURL, setAppURL] = useState<string | null>(null);
    const [visible, setVisible] = useState(false);
    const location = useLocation();

    const {lockScroll, unlockScroll} = useScrollLock();

    useEffect(() => {
        if(visible){
            lockScroll();
        }

        return () => {
            unlockScroll();
        }
    }, [visible])

    useEffect(() => {
        const userMobileOS = getMobileOSIfWeb();
        if (!userMobileOS || socialAccounts.length < 1 || process.env.REACT_APP_ENV === "development") return;

        const ignoredAt = localStorage.getItem(APP_POPUP_IGNORE_KEY);

        if (ignoredAt) {
            const ignoredTime = Number(ignoredAt);
            if (!Number.isNaN(ignoredTime)) {
                const diff = Date.now() - ignoredTime;
                if (diff < IGNORE_DURATION_MS) return;
            }
        }

        if (userMobileOS === "android") {
            showPopup(MOBILE_APP_URLS.android);
        } else if (userMobileOS === "ios") {
            showPopup(MOBILE_APP_URLS.ios);
        }
    }, [location, socialAccounts]);

    const showPopup = (url: string) => {
        setTimeout(() => {
            setAppURL(addAppDownloadUTMParams(url));
            requestAnimationFrame(() => setVisible(true));
        }, POPUP_DELAY_MS);
    };

    const handleClose = () => {
        analyticsLog('app_download_closed');
        localStorage.setItem(APP_POPUP_IGNORE_KEY, Date.now().toString());
        setVisible(false);

        setTimeout(() => {
            setAppURL(null);
        }, 300);
    };

    if (!appURL) return null;

    return (
        <div
            id="ad-timed-2"
            className={`menu menu-box-modal menu-box-detached menu-active app-modal ${
                visible ? "app-modal--visible" : ""
            }`}
            data-menu-width="cover"
            data-menu-height="cover"
            data-menu-effect="menu-over"
            style={{ display: "block", width: "100%", height: "100%" }}
        >
                <div className="get-mobile-app position-relative w-100 h-100">
                    <button
                        type="button"
                        onClick={handleClose}
                        aria-label="Close"
                        className="get-mobile-app__close btn p-0 position-absolute"
                    >
                        <span className="get-mobile-app__closeIcon">×</span>
                    </button>

                    <img
                        alt=""
                            src={GridBG}
                            className="get-mobile-app__bgVector position-absolute"
                    />

                    <div className="get-mobile-app__logo position-absolute">
                        <img alt="Influns" src={AppLogo} className="get-mobile-app__logoImg" />
                    </div>

                    <p className="get-mobile-app__tagline position-absolute m-0">
                        Where your influence matters.
                    </p>

                    <a
                        href={appURL}
                        target="_blank"
                        rel="noreferrer"
                        className="get-mobile-app__cta position-absolute text-decoration-none"
                    >
                        <span className="get-mobile-app__ctaText">GET THE APP</span>
                    </a>
                </div>
        </div>
    );
};

export default GetMobileApp;
